import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const ShareFolderSettings = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
      <g id="Groupe_5547" data-name="Groupe 5547" transform="translate(-1385 -346)">
        <circle id="Ellipse_457" data-name="Ellipse 457" cx="32.5" cy="32.5" r="32.5" transform="translate(1385 346)" fill="#ed6a5a"/>
        <circle id="Ellipse_458" data-name="Ellipse 458" cx="4.5" cy="4.5" r="4.5" transform="translate(1413 361)" fill="#fff"/>
        <circle id="Ellipse_459" data-name="Ellipse 459" cx="4.5" cy="4.5" r="4.5" transform="translate(1413 374)" fill="#fff"/>
        <circle id="Ellipse_460" data-name="Ellipse 460" cx="4.5" cy="4.5" r="4.5" transform="translate(1413 387)" fill="#fff"/>
      </g>
    </svg>
  </SvgIcon>
);

export default ShareFolderSettings;